import angular from 'angular';
import UserForm from './user-form/user-form.component';
import UserTable from './user-table/user-table.component';
import Routes from './user.routes';

export default angular.module('autoboard.userManagement', [UserForm, UserTable])
  .config(Routes)
  .name;